export default "__VITE_ASSET__6e8e7516__"